














import '../../styles/small-display.css'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    children: {
      type: [String, Object],
      default: 'div',
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  name: 'SmallDisplay',
})
